const isDetached = (renderer) => !renderer.element.sheet;

const always = () => true;
const withoutNativeParent = ([, , nativeParent]) => nativeParent === undefined;

const GUARDS = [
  { method: "deleteRule", fallback: () => false, applies: always },
  { method: "replaceRule", fallback: () => false, applies: always },
  { method: "insertRule", fallback: () => false, applies: withoutNativeParent },
  { method: "getRules", fallback: () => [], applies: always },
];

const firstCallOnly = (fn) => {
  const calls = { made: 0 };
  return () => {
    calls.made += 1;
    return calls.made === 1 ? fn() : undefined;
  };
};

export const guardRenderer = (Renderer, { onDetached }) => {
  const reportDetached = firstCallOnly(onDetached);
  const skip = (fallback) => {
    reportDetached();
    return fallback();
  };

  const guarded =
    (renderer) =>
    ({ method, fallback, applies }) =>
      [
        method,
        (...args) =>
          isDetached(renderer) && applies(args)
            ? skip(fallback)
            : Reflect.apply(Renderer.prototype[method], renderer, args),
      ];

  // JSS calls `new options.Renderer(sheet)`; returning an object from a constructor replaces `this`.
  return function GuardedRenderer(sheet) {
    const renderer = new Renderer(sheet);
    return Object.assign(
      renderer,
      Object.fromEntries(GUARDS.map(guarded(renderer))),
    );
  };
};
